<template>
  <div class="user-info-card clearfix">
    <form>
      <div class="row">
        <label class="control-label">旺旺: </label>
        <input type="text" placeholder="请输入旺旺号" v-model="userName" :class="{warning: warning.name}" @focus="focusInput('name')" :value="content.contactWangWang">
      </div>
      <div class="row">
        <label class="control-label">联系电话: </label>
        <input type="tel" placeholder="请输入联系电话" v-model="userTel" :class="{warning: warning.tel}" @focus="focusInput('tel')">
      </div>
      <div class="row">
        <label class="control-label">邮箱: </label>
        <input type="email" placeholder="请输入邮箱" v-model="userEmail" :class="{warning: warning.email}" @focus="focusInput('email')">
      </div>
    </form>
    <button class="btn card-btn" @click="sendUserInfo">确定</button>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        userName: '',
        userTel: '',
        userEmail: '',
        warning: {
          name: false,
          tel: false,
          email: false
        }
      }
    },
    methods: {
      sendUserInfo() {
        var me = this;
        var telReg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
        var emailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(me.userName.trim() && me.userTel.trim() && me.userEmail.trim() &&
          telReg.test(me.userTel) && emailReg.test(me.userEmail)){
          var info = {
            userName: me.userName,
            userTel: me.userTel,
            userEmail: me.userEmail
          };
          me.$dispatch('send-info', '您的个人信息已经输入完成！', info);
        }
        else {
          if(!me.userName.trim()){
            me.warning.name = true;
          }
          if(!me.userTel.trim() || !telReg.test(me.userTel)){
            me.warning.tel = true;
          }
          if(!me.userEmail.trim() || !emailReg.test(me.userEmail)){
            me.warning.email = true;
          }
        }
      },
      focusInput(key) {
        var me = this;
        switch(key) {
          case 'name':
            me.warning.name = false;
            break;
          case 'tel':
            me.warning.tel = false;
            break;
          case 'email':
            me.warning.email = false;
            break;
        }
      }
    },
    props: {
      content: {
        type: Object
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/base.less";
  .user-info-card {
    width: 310px;
    margin-left: 62px;
    background-color: #fff;
    border: 1px solid @lightGray;
    border-top: 4px solid @main-color;

    .row {
      margin-top: 10px;

      .control-label {
        display: inline-block;
        width: 90px;
        font-size: 12px;
        text-align: right;
        margin-bottom: 0;
        padding: 5px 10px 5px 0;
      }
      .warning {
        border-color: #843534;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;
      }
    }
    .card-btn {
      float: right;
      margin: 12px 26px 10px 0;
    }
  }
</style>


// WEBPACK FOOTER //
// UserInfoCard.vue?ef5432a8